module.exports = __webpack_public_path__ + "public/images/slider/potapov-circle.7ddd4ebc6bd167a1a61f8539b265e7ca.webp";